export interface GroupByPeriodFilterType {
  groupBy: server.dto.PeriodOptions
}

export const initialGroupByPeriodFilter: GroupByPeriodFilterType = {
  groupBy: "year"
};